export const FIELD_TEMPLATE_FETCH_REQUEST = 'FIELD_TEMPLATE_FETCH_REQUEST';
export const FIELD_TEMPLATE_FETCH_REQUEST_SUCCESS = 'FIELD_TEMPLATE_FETCH_REQUEST_SUCCESS';
export const FIELD_TEMPLATE_FETCH_REQUEST_FAILURE = 'FIELD_TEMPLATE_FETCH_REQUEST_FAILURE';

export const FIELD_TEMPLATE_UPSERT_REQUEST = 'FIELD_TEMPLATE_UPSERT_REQUEST';
export const FIELD_TEMPLATE_UPSERT_REQUEST_SUCCESS = 'FIELD_TEMPLATE_UPSERT_REQUEST_SUCCESS';
export const FIELD_TEMPLATE_UPSERT_REQUEST_FAILURE = 'FIELD_TEMPLATE_UPSERT_REQUEST_FAILURE';

export const FIELD_TEMPLATE_DELETE_REQUEST = 'FIELD_TEMPLATE_DELETE_REQUEST';
export const FIELD_TEMPLATE_DELETE_REQUEST_SUCCESS = 'FIELD_TEMPLATE_DELETE_REQUEST_SUCCESS';
export const FIELD_TEMPLATE_DELETE_REQUEST_FAILURE = 'FIELD_TEMPLATE_DELETE_REQUEST_FAILURE';

export const FIELD_TEMPLATE_CLEAN_REQUEST = 'FIELD_TEMPLATE_CLEAN_REQUEST';